module.exports = __webpack_public_path__ + "img/green-plug.517aa7c2.webp";